<template>
  <div
    :ref="generateSafeId(fieldQuestionId, 'wrapper')"
    class="RMPE-DynamicField"
    :class="{ 'RMPE-HasError': fieldHasError }"
  >
    <component
      :is="layout.type"
      :image="layout.image"
      :video="layout.video"
    >
      <div class="field">
        <div class="control is-expanded">
          <label
            :for="fieldQuestionId"
            class="label RMPE-DynamicField-Label m-b-none"
          >
            <span
              :class="{'RMPE-Required': question.required}"
              v-html="question.formattedLabel"
            />
          </label>

          <HintMessage :hint="question.formattedDescription" />

          <MediaMiddlePartial :layout="layout" />

          <div
            class="is-fullwidth"
            @click="setShowDropdown"
          >
            <VueSelect
              :id="fieldQuestionId"
              ref="auto-focus-target"
              :value="fieldValue"
              :options="options"
              :class="{ 'is-danger': fieldHasError }"
              v-bind="autocompleteConfig"
              @input="setSelected"
              @search="setShowDropdown"
            />
            <ErrorMessage
              :errors="error.errors"
              :is-blurred="isBlurred"
              :field-has-error="fieldHasError"
            />
          </div>
        </div>
        <div class="RMPE-DynamicForm-SubmitContainer">
          <button
            :disabled="isNextButtonDisabled"
            class="button is-primary RMPE-CustomSubmit"
            @click="goToNextQuestion"
          >
            {{ question.goToNextQuestionButtonLabel }}
          </button>
        </div>
      </div>
    </component>
  </div>
</template>

<script>
import DynamicFieldMixin from '../../mixins/dynamic-field-mixin';
import AutocompleteFieldMixin from '../common/autocomplete-field';

export default {
  mixins: [DynamicFieldMixin, AutocompleteFieldMixin],

  methods: {
    autoFocusField() {
      if (!this.autoFocusFirstField) return;

      if (this.isTouchDevice) {
        this.$refs[this.generateSafeId(this.fieldQuestionId, 'wrapper')].scrollIntoView();
        return;
      }

      this.$refs['auto-focus-target'].$refs.search.focus();
    },
  },
};
</script>

<style scoped lang="scss">
.field {
  .is-danger {
    ::v-deep .vs__dropdown-toggle {
      border-color: black !important;
    }
  }
}
</style>
